exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na {\n  cursor: pointer;\n}\n.main {\n  padding-top: 30px;\n}\n", ""]);

// exports
